import useFetch from "../../hooks/useFetch";
import UserService from "../UserService";
import { IUserData, UserLoginRequest } from "../../types/services-types/user-types";
import { setAuth } from "../../store/reducers/user-reducer";
import { useAppDispatch } from "../../store";

export default function useLogin(payload: UserLoginRequest) {
    const dispatch = useAppDispatch()
    const [login, isLoading, error, errors] = useFetch(async () => {
        const data = await UserService.Login(payload)
        localStorage.setItem('accessToken', data.tokens.access_token)
        dispatch(setAuth(data.user))
        return data
})

return {login, isLoading, error, errors}
}